var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.dataBoard.name.$error } },
        [
          _c("label", [
            _vm._v(" Board Name "),
            _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { placeholder: "This is board name" },
            model: {
              value: _vm.$v.dataBoard.name.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.dataBoard.name, "$model", $$v)
              },
              expression: "$v.dataBoard.name.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.dataBoard.description.$error } },
        [
          _c("label", [_vm._v(" Description")]),
          _vm._v(" "),
          _c("j-textarea", {
            attrs: { placeholder: "This is description" },
            model: {
              value: _vm.$v.dataBoard.description.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.dataBoard.description, "$model", $$v)
              },
              expression: "$v.dataBoard.description.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.mode === "update"
        ? _c(
            "div",
            { staticClass: "card-field-container" },
            [
              _c("j-form-master", {
                ref: "jFormMasterData",
                attrs: { "list-field": _vm.listField }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("br")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e704450", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e704450","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/board/form/jBoardForm.vue
// module id = null
// module chunks = 